var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isFullLayout)?_c('AdminPortalPage'):_c('AdminPortalMain',{attrs:{"activeRoute":_vm.activeRoute,"headerTitle":_vm.pageTitle,"returnPath":_vm.returnPath,"tooltipProps":_vm.tooltipProps}}),_c('TheModal',{ref:"theModal",class:_vm.$style.modalContainer})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }